import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { LoginModule } from './login/login.module';
import { ModalRegistrationModule } from './modal-registration/modal-registration.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { ModalForgotPassModule } from './modal-forgot-pass/modal-forgot-pass.module';
import { ResetPasswordModule } from './reset-password/reset-password.module';

import { FirstTimeUserSetupModule } from './first-time-user-setup/first-time-user-setup.module';

@NgModule({
  imports: [
    IonicModule,
    LoginModule,
    RouterModule,
    ModalRegistrationModule,
    AuthRoutingModule,
    ModalForgotPassModule,
    ResetPasswordModule,
    FirstTimeUserSetupModule,
  ],
  exports: [],
  declarations: [AuthComponent],
  providers: [],
})
export class AuthModule {}
